import Axios from "axios"
import { orderBy } from "lodash"
import { SellerAccountStatementModel } from "../models/SellerAccountStatementModel"
import { API_ADMIN } from "../../utils/constants/Api"
import { IFilterList, IFilterListWithoutPagination } from "../../utils/interfaces/FilterListInterface"
import { SellerCurrentBalanceModel } from "../models/SellerCurrentBalanceModel"
import { SellerModel } from "../models/SellerModel"
import { AttachmentModel } from "../../utils/models/AttachmentModel"
import { AttachmentCreationModel } from "../../utils/models/AttachmentCreationModel"

export default {
    getSellerList(page:number, filter:IFilterList):Promise<SellerModel[]> {
        return Axios.get(`${API_ADMIN}sellers?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return orderBy(data.map((s:SellerModel) => new SellerModel(s)), ['name'], ['asc'])
            })
    },
    getSellerById(id:string):Promise<SellerModel> {
        return Axios.get(`${API_ADMIN}sellers/${id}`)
            .then(({data}) => {
                return new SellerModel(data)
            })
    },
    getSellersAccountStatement(idSeller:string, filter:IFilterListWithoutPagination):Promise<SellerAccountStatementModel[]> {
        return Axios.get(`${API_ADMIN}sellers/${idSeller}/account_statements${filter.toQueryString()}`)
            .then(({data}) => {
                return data.map((s:SellerAccountStatementModel) => new SellerAccountStatementModel(s))
            })
    },
    getSellersAccountStatementById(idSellerAccountStatement:string):Promise<SellerAccountStatementModel> {
        return Axios.get(`${API_ADMIN}sellers/account_statements/${idSellerAccountStatement}`)
            .then(({data}) => {
                return new SellerAccountStatementModel(data)
            })
    },
    getSellersCurrentBalance(idSeller:string):Promise<SellerCurrentBalanceModel> {
        return Axios.get(`${API_ADMIN}sellers/${idSeller}/account_statements/current_balance`)
            .then(({data}) => {
                return new SellerCurrentBalanceModel(data)
            })
    },
    getAttachmentList(idSellerAccount: number):Promise<AttachmentModel[]> {
        return Axios.get(`${API_ADMIN}sellers/account_statements/${idSellerAccount}/attachments`)
            .then(({data}) => {
                return data.map((a: AttachmentModel) => new AttachmentModel(a))
            })
    },
    insertAttachmentList(idSellerAccount: number, attachmentList: AttachmentCreationModel[]):Promise<any> {
        return Axios.post(`${API_ADMIN}sellers/account_statements/${idSellerAccount}/attachments`, attachmentList)
            .then(({data}) => {
                return data
            })
    },
    deleteAttachment(idSellerAccount: number, filename: string):Promise<any> {
        return Axios.delete(`${API_ADMIN}sellers/account_statements/${idSellerAccount}/attachments/${filename}`)
    },
}

